class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.onWindowScroll = this.onWindowScroll.bind(this);
    this.onCatalogLinkClick = this.onCatalogLinkClick.bind(this);
    this.ignoreScrollCloseUntil = 0;
    window.addEventListener('scroll', this.onWindowScroll, { passive: true });
    this.mainDetailsToggle.addEventListener('click', this.onCatalogLinkClick);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onCatalogLinkClick(event) {
    if (event.target.closest('[data-ff-open-brand], [data-ff-brands-back]')) return;
    const link = event.target.closest('a[href]');
    if (!link || !this.mainDetailsToggle.contains(link)) return;
    // Let catalog deep-links navigate; don't let scroll-close cancel the jump.
    this.ignoreScrollCloseUntil = Date.now() + 800;
    this.close();
    if (this.header) this.header.preventHide = false;
  }

  onWindowScroll() {
    if (!this.mainDetailsToggle.open) return;
    if (Date.now() < this.ignoreScrollCloseUntil) return;
    this.close();
    if (this.header) this.header.preventHide = false;
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onWindowScroll);
    this.mainDetailsToggle.removeEventListener('click', this.onCatalogLinkClick);
  }
}

customElements.define('header-menu', HeaderMenu);
